import { BreadcrumbsState } from './state';
import { BreadcrumbsAction, DEL_BREADCRUMBS, SET_BREADCRUMBS } from './types';

const initialBreadcrumbsState = {} as BreadcrumbsState;

export default function breadcrumbReducer(
    breadcrumbs: BreadcrumbsState = initialBreadcrumbsState,
    action: BreadcrumbsAction
): BreadcrumbsState {
    switch (action.type) {
        case SET_BREADCRUMBS:
            return action.payload;

        case DEL_BREADCRUMBS:
            return {} as BreadcrumbsState;

        default:
            return breadcrumbs;
    }
}
